<wbo-select-option [value]="KvdDocketButtonType.BUMP" label="wbo.order-processor.edit.option.kvdDocketButtonType.bump">
</wbo-select-option>
<wbo-select-option [value]="KvdDocketButtonType.TRANSITION" label="wbo.order-processor.edit.option.kvdDocketButtonType.transition">
</wbo-select-option>
